import React, { Component, Fragment } from 'react';
import classNames from 'classnames';
import {
  AppBar,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Toolbar,
  Typography,
  Drawer
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

import { NavLink } from 'react-router-dom';
import {
  KeyboardArrowLeft as CloseMenuIcon,
  KeyboardArrowRight as OpenMenuIcon,
  Home as HomeIcon,
  ExitToApp as ExitIcon,
  VideoLibrary as VideoLibraryIcon
} from '@material-ui/icons';
import './style.css';

const styles = theme => ({
  appBar: {
    position: 'absolute',
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    zIndex: theme.zIndex.drawer + 1
  },
  drawerPaper: {
    position: 'relative',
    minHeight: '100%',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    }),
    width: theme.overrides.MuiDrawer.paper.width
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    width: theme.overrides.MuiDrawer.paper.minWidth
  },
  toolbar: theme.mixins.toolbar
});

const Nav = class extends Component {
  render = () => {
    const { authUser, classes, menuOpen, toggleDrawer, returnUrl } = this.props;

    const MenuActionIcon = menuOpen ? CloseMenuIcon : OpenMenuIcon;

    return (
      <Fragment>
        <AppBar className={classes.appBar}>
          <Toolbar>
            <Typography variant="headline">Video Services</Typography>
            {authUser && (
              <Typography variant="subheading" color="inherit">
                {`${authUser.attributes.nameFirst} ${
                  authUser.attributes.nameLast
                }`}
              </Typography>
            )}
          </Toolbar>
        </AppBar>
        {authUser && (
          <Drawer
            variant="persistent"
            anchor="left"
            classes={{
              paper: classNames(
                classes.drawerPaper,
                !menuOpen && classes.drawerPaperClose
              )
            }}
            open={true}
          >
            <div className={classes.toolbar} />
            <List component="nav">
              <div className="navLink toggle">
                <ListItem button className="toggle" onClick={toggleDrawer}>
                  <ListItemIcon>
                    <MenuActionIcon />
                  </ListItemIcon>
                </ListItem>
              </div>
              <NavLink
                to="/"
                className="navLink"
                activeClassName="activeNavLink"
                exact
              >
                <ListItem button>
                  <ListItemIcon>
                    <HomeIcon />
                  </ListItemIcon>
                  <ListItemText primary="Home" />
                </ListItem>
              </NavLink>
              <NavLink
                to="/library"
                className="navLink"
                activeClassName="activeNavLink"
              >
                <ListItem button>
                  <ListItemIcon>
                    <VideoLibraryIcon />
                  </ListItemIcon>
                  <ListItemText primary="Video Library" />
                </ListItem>
              </NavLink>
              {returnUrl && (
                <div className="navLink">
                  <a href={returnUrl}>
                    <ListItem button>
                      <ListItemIcon>
                        <ExitIcon className="exit-icon" />
                      </ListItemIcon>
                      <ListItemText primary="Exit" />
                    </ListItem>
                  </a>
                </div>
              )}
            </List>
          </Drawer>
        )}
      </Fragment>
    );
  };
};

export default withStyles(styles)(Nav);



// WEBPACK FOOTER //
// ./src/components/layout/Nav.js